import type { FC } from "react";

import { DropdownMenuCheckboxItemNoIndicator } from "@/components/atoms";
import { formatTestId } from "@/utils/formatTestId";

import type { SubMenuConfig } from "../types";

interface MainSubMenuProps {
  menuList: string[];
  selectedMap: Record<string, string[]>;
  handleMenuClick: (a: string) => void;
  subMenuRegistry: Record<string, SubMenuConfig>;
}

const MainSubMenu: FC<MainSubMenuProps> = ({
  menuList,
  selectedMap,
  handleMenuClick,
  subMenuRegistry,
}) => {
  return menuList.map(elem => {
    const selectedCount = selectedMap[elem]?.length || 0;
    const isChecked = selectedCount > 0;
    const testId = `main-submenu-item-${formatTestId(elem)}`;

    const isDisabled = subMenuRegistry[elem]?.disabled;

    return (
      <DropdownMenuCheckboxItemNoIndicator
        key={elem}
        checked={isChecked}
        onCheckedChange={() => handleMenuClick(elem)}
        data-testid={testId}
        disabled={isDisabled}
      >
        <span className="text-sm flex justify-between w-full">{elem}</span>
      </DropdownMenuCheckboxItemNoIndicator>
    );
  });
};

export default MainSubMenu;
